
// @ts-nocheck
import { defineComponent, ref } from 'vue'
import { TrapFocus } from '@/components/directives'
import { isValidWidthUnit } from '@/components/utils/validators'

import { Overlay } from '@/components/overlay'
import {
  // eslint-disable-next-line import/no-named-default
  default as useDialog,
  CLOSE_EVENT,
  CLOSED_EVENT,
  OPEN_EVENT,
  OPENED_EVENT,
  UPDATE_MODEL_EVENT
} from './useDialog'

import type { PropType, SetupContext } from 'vue'

export default defineComponent({
  name: 'ElDialog',

  components: {
    'el-overlay': Overlay
  },
  directives: {
    TrapFocus
  },
  props: {
    appendToBody: {
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line vue/require-default-prop
    beforeClose: {
      type: Function as PropType<(...args: any[]) => unknown>
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    modal: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    openDelay: {
      type: Number,
      default: 0
    },
    closeDelay: {
      type: Number,
      default: 0
    },
    top: {
      type: String,
      default: null
    },
    modelValue: {
      type: Boolean,
      required: true
    },
    // eslint-disable-next-line vue/require-default-prop
    modalClass: String,
    width: {
      type: [String, Number],
      default: '50%',
      validator: isValidWidthUnit
    },
    // eslint-disable-next-line vue/require-default-prop
    zIndex: {
      type: Number
    },
    // Hiển thị header
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  emits: [
    OPEN_EVENT,
    OPENED_EVENT,
    CLOSE_EVENT,
    CLOSED_EVENT,
    UPDATE_MODEL_EVENT
  ],
  setup (props, ctx) {
    const dialogRef = ref(null)
    return {
      ...useDialog(props, ctx as SetupContext, dialogRef),
      dialogRef
    }
  }
})
